import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";

const CreateEditUserDialog = ({ ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      onClose={props.closeCreateUserDialog}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        align="center"
        style={{ color: "#001753", marginBottom: "15px" }}
      >
        {props.userDTO.id ? "Edit user" : "Create user"}
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{ display: "flex", flexDirection: "column", padding: "10px" }}
          style={{ minWidth: "300px" }}
          autoComplete="off"
        >
          <TextField
            id="outlined-basic"
            label="Company"
            variant="outlined"
            placeholder="Company"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.company || ""}
            onChange={(e) =>
              props.setUserDTO({ ...props.userDTO, company: e.target.value })
            }
          />
          <TextField
            id="outlined-basic"
            label="Name"
            variant="outlined"
            placeholder="Name"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.name || ""}
            onChange={(e) =>
              props.setUserDTO({ ...props.userDTO, name: e.target.value })
            }
          />
          <TextField
            id="outlined-multiline-flexible"
            label="Surname"
            placeholder="Surname"
            style={{ marginBottom: "25px", width: "100%" }}
            multiline
            value={props?.userDTO.surname || ""}
            onChange={(e) =>
              props.setUserDTO({
                ...props.userDTO,
                surname: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Email that is username"
            placeholder="Email that is username"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.username || ""}
            onChange={(e) =>
              props.setUserDTO({
                ...props.userDTO,
                username: e.target.value,
              })
            }
          />
          {props.userDTO.id ? null : (
            <TextField
              id="outlined-basic"
              label="Password"
              placeholder="Password"
              variant="outlined"
              style={{ marginBottom: "25px", width: "100%" }}
              value={props?.userDTO.password || ""}
              onChange={(e) =>
                props.setUserDTO({
                  ...props.userDTO,
                  password: e.target.value,
                })
              }
            />
          )}
          <TextField
            id="outlined-basic"
            label="Phone"
            placeholder="Phone"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.phone || ""}
            onChange={(e) =>
              props.setUserDTO({
                ...props.userDTO,
                phone: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Post code"
            placeholder="Post code"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.postCode || ""}
            onChange={(e) =>
              props.setUserDTO({
                ...props.userDTO,
                postCode: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Place"
            placeholder="Place"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.place || ""}
            onChange={(e) =>
              props.setUserDTO({
                ...props.userDTO,
                place: e.target.value,
              })
            }
          />
          <TextField
            id="outlined-basic"
            label="Address"
            placeholder="Address"
            variant="outlined"
            style={{ marginBottom: "25px", width: "100%" }}
            value={props?.userDTO.address || ""}
            onChange={(e) =>
              props.setUserDTO({
                ...props.userDTO,
                address: e.target.value,
              })
            }
          />
          {props.userDTO.id ? null : (
            <div className="checkbox" style={{ marginRight: "15px" }}>
              <input
                id="input-1"
                type="checkbox"
                onChange={() => props.setTermsAndCond(!props.termsAndCond)}
                checked={props.termsAndCond}
              />
              <label htmlFor="input-1"></label>
            </div>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeCreateUserDialog}>
          Close
        </Button>
        <Button
          onClick={props.userDTO.id ? props.editUser : props.crateNewUser}
          autoFocus
        >
          {props.userDTO.id ? "Edit" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateEditUserDialog;
